import React, { useState, useEffect } from 'react';

import Form from './Form';
import Report from './Report';

import './styles.scss';

const maxSelected = 9;

export default function Comparison(props) {
  const [report, setReport] = useState(false);
  const [geoType, setGeoType] = useState('countries');
  const [selected, setSelected] = useState([]);

  const { data } = props;

  useEffect(() => {
    const selection = data.regions
      .map(r => geoType === 'regions' ? r.key : [])
      .reduce((a, c) => a.concat(c), []);
    setSelected(selection);
  }, [geoType, data.regions]);

  function toggleGeo(g) {
    if (selected.includes(g)) {
      setSelected(selected.filter(s => s !== g));
    } else {
      if (selected.length < maxSelected) {
        setSelected(selected.concat([g]));
      }
    }
  }

  return (
    <div className='Comparison'>
      {report ? (
        <Report
          data={data}
          geoType={geoType}
          selected={selected}
          setReport={setReport}
          language={props.language}
        />
      ) : (
        <Form
          regions={data.regions}
          selected={selected}
          maxSelected={maxSelected}
          toggleGeo={toggleGeo}
          geoType={geoType}
          setGeoType={setGeoType}
          setReport={setReport}
        />
      )}
    </div>
  );
}